import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const TemplateSelectorContainer = styled.div`
	display: inline-flex;
	flex-direction: column;
	gap: 1rem;
	margin-right: var(--margin-3);

	body[dir='rtl'] & {
		margin-left: var(--margin-3);
		margin-right: unset;
	}

	@media ${Breakpoints.mobile} {
		margin-bottom: var(--margin-3);
	}
`;

export const Miniscreen = styled.div`
	cursor: pointer;
	position: relative;
	z-index: 1;
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	> img {
		border-radius: var(--small-border-radius);
		:hover {
			filter: blur(1px);
			& + span.dark-container {
				display: block;
				svg {
					display: block;
				}
			}
		}
	}

	&.selected {
		border: 1px solid var(--blue);
		border-radius: var(--small-border-radius);
		position: relative;
		display: flex;
	}

	.selected-badge {
		position: absolute;
		bottom: 0px;
		z-index: 1;
		right: 0px;
		background: var(--blue);
		color: white;
		padding: 0.3rem 0.5rem;
		border-top-left-radius: var(--small-border-radius);
		border-bottom-right-radius: 2px;
		font-size: var(--paragraph3-font-size);
	}
`;

export const DarkContainer = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	border-radius: var(--small-border-radius);
	width: 20rem;
	height: 100%;
	z-index: 9;
	transition: all 0.2s ease-in-out;

	.button {
		display: none;
		> .icon {
			font-size: 1.2rem !important;
			transition: all 0.2s ease-in-out;
		}

		:hover {
			> .icon {
				font-size: 1.8rem !important;
			}
		}
	}

	:hover {
		.button {
			display: flex;
			transition: all 0.2s ease-in-out;
		}

		background-color: #00000010;
		& ~ img {
			filter: blur(2px);
		}
	}

	@media ${Breakpoints.mobile} {
		.button {
			display: flex;

			> .icon > svg {
				padding: 0.5rem;
			}
		}
	}
`;

export const IconDiv = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	width: 100%;
	position: absolute;
`;

export const TemplateImage = styled(Image)`
	padding-top: 4rem;
`;
